<template>
  <div v-if="isLoaded">
    <div class="mgt-20px">
      <information-ordre-travail-into-commande :ordreTravails="ordresTravails"
            v-if="ordresTravails && ordresTravails.length > 0">
      </information-ordre-travail-into-commande>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>
          {{$t('editionCommande.logistique.saleProduct')}}
        </p>
      </header>
      <div class="card-content">

        <div v-if="hasNotFilteredLigneCommande"
            class="card card-article-any has-background-white mgb-20px">
          <div class="card-content has-text-centered">
            <br>
            <h1 class="title is-size-4">
              {{ this.$t('editionCommande.logistique.anyArticleTitle')}}
            </h1>
            <p>
              {{ this.$t('editionCommande.logistique.anyArticleText')}}
            </p>
          </div>
        </div>
        <div class="card mgb-20px"
            :class="{ 'has-background-table-background': !ligneCommande.id }"
            v-for="ligneCommande in filteredLignesCommande" :key="ligneCommande.ordre">
          <ligne-commande-presse
            :ligneCommande="ligneCommande"
            v-if="isPresse(ligneCommande)">
          </ligne-commande-presse>
          <ligne-commande
            :commande="commande"
            :ligne="ligneCommande"
            :toutesLignesCommandesIds="getLignesCommandesIds()"
            :devisCommandeId="commande.id"
            :commercialId="commande.commercialId"
            :assistantId="commande.assistantId"
            @deleteLigne="deleteLigne(ligneCommande)"
            :isDevis="isDevis" v-else>
          </ligne-commande>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import * as produitConf from '@/configuration/catalogue/produitConf';
import ligneCommande from '@/components/commande/logistique/ligneCommande';
import informationOrdreTravailIntoCommande
  from '@/components/devisCommandes/editionDevisCommande/informationOrdreTravailIntoCommande';
import ligneCommandePresse from '@/components/commande/logistique/ligneCommandePresse';
import { createNamespacedHelpers } from 'vuex';
import { getAll as getAllDemandeImpression } from '@/api/logistique/demandeImpression';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    commande: Object,
    breadcrumb: {
      type: Array,
      required: true,
    },
    ordresTravails: {
      type: Array,
      required: false,
    },
    isDevis: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  components: {
    ligneCommande,
    informationOrdreTravailIntoCommande,
    ligneCommandePresse,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    filteredLignesCommande() {
      return this.commande.lignesCommande
        .filter(l => !!l.typeProduit);
    },
    hasNotFilteredLigneCommande() {
      return !this.filteredLignesCommande || this.filteredLignesCommande.length === 0;
    },
    moduleDemandeImpression() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.demandeImpression.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    isPresse(ligneCommande) {
      return ligneCommande.typeProduit === produitConf.CATEGORIE_PRESSE;
    },
    deleteLigne(ligne) {
      const index = this.commande.lignesCommande.findIndex((ligneFromCommande) => {
        return ligne.produitId === ligneFromCommande.produitId
        && ligneFromCommande.dateDebut === ligne.dateDebut
        && ligne.dateFin === ligneFromCommande.dateFin;
      });
      this.commande.lignesCommande.splice(index, 1);
    },
    getLignesCommandesIds() {
      return this.commande.lignesCommande.filter(ligne => ligne.id)
        .map(ligne => ligne.id);
    },
    async loadDemandesImpresssions() {
      const data = {
        query: {
          ligneCommandeIds: this.getLignesCommandesIds(),
          societeId: this.societeActiveId,
        },
        SkipCount: 0,
      };
      const demandesImpressions = (await getAllDemandeImpression(data)).data.result.items;
      this.commande.lignesCommande.forEach(ligne => {
        ligne.demandesImpressions = demandesImpressions.filter(
          demande => demande.ligneCommandeId === ligne.id);
      });
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.demandeImpression.key,
      ]);
      if (this.moduleDemandeImpression) await this.loadDemandesImpresssions();
      this.isLoaded = true;
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
